import 'css/src/components/public-pages/Title';

import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import type { Document } from '@contentful/rich-text-types';

import { BUTTON_SIZES, PrimaryButton } from 'js/src/components/common/ui/Button';
import { addUtmParams } from 'js/src/libs/add-utm';
import type { ImmutableMap } from 'js/src/libs/consts';

type Props = {
    data: ImmutableMap<{
        title: string;
        subheading: Document;
        cta_url?: string;
        cta_text?: string;
    }>;
    bgColor: string;
};

const Title = React.memo(function Title({ data, bgColor }: Props) {
    let titleNode = null;
    if (data.get('title')) {
        titleNode = <h3 className="text-center">{data.get('title')}</h3>;
    }

    let subheadingNode = null;
    if (data.get('subheading')) {
        subheadingNode = (
            <h5 className="text-center">
                {documentToReactComponents(data.get('subheading').toJS())}
            </h5>
        );
    }

    let cta = null;

    const ctaUrl = data.get('cta_url');
    const ctaText = data.get('cta_text');

    if (ctaUrl && ctaText) {
        const url = addUtmParams(ctaUrl, ctaText);
        cta = <PrimaryButton href={url} size={BUTTON_SIZES.LG} text={ctaText} />;
    }

    if (!subheadingNode && !titleNode) {
        return null;
    }

    return (
        <div className="contentful-component title" style={{ backgroundColor: bgColor }}>
            <div className="container">
                <div className="row">
                    <div className="col-sm-8 offset-sm-2">
                        {titleNode}
                        {subheadingNode}
                        {cta && <div className="text-center mt-l5-24">{cta}</div>}
                    </div>
                </div>
            </div>
        </div>
    );
});

export default Title;
